define('warollcalculator', ['jquery'], function ($) {

  var warollcalculator = {
    bindEvents: function bindEvents() {
      var _this = this;

      $('.product__fullinfo').on('keyup keydown change blur', '#calculateQM', function (e) {
        var self = $(e.currentTarget);
        var value = self.val();
        var input = $('.product__fullinfo #amountToBasket');

        self.val().length > 0 ? input.val(_this.calcRoll(value)) : input.val(1);
      });

      $('.product__fullinfo').on('keyup keydown change blur', '#amountToBasket', function (e) {
        var self = $(e.currentTarget);
        var value = self.val();
        var input = $('.product__fullinfo #calculateQM');

        value.length > 0 ? input.val(_this.calcRollQm(value)) : input.val(1);
      });

      $('.product__fullinfo').on('keyup', '#txtWallWidth', function (e) {
        var self = _this;
        var target = $(e.currentTarget);
        var value = target.val();

        if (_this.timer != null) {
          clearTimeout(self.timer);
        }
        self.timer = setTimeout(function () {
          value.length > 0 ? self.calculate() : '';
        }, 2000);
      });

      $('.product__fullinfo').on('keyup', '#txtWallHeight', function (e) {
        var self = _this;
        var target = $(e.currentTarget);
        var value = target.val();

        if (_this.timer != null) {
          clearTimeout(self.timer);
        }
        self.timer = setTimeout(function () {
          value.length > 0 ? self.calculate() : '';
        }, 2000);
      });
    },
    changeSelect: function changeSelect(obj) {
      var thisObj = $(obj),
          thisRadio = thisObj.find(".radioBtn"),
          thisObjID = thisRadio.val();

      thisObj.parents(".product__select").find(".hiddenSelectBox li a.dsi-" + thisObjID).trigger("click");
    },

    /*calcStripsPerRoll(height, rollLength, repeat) {
      var retval = rollLength / (height + repeat);
      if (retval < 0) {
        return 1;
      }
      return Math.ceil(retval);
    },*/
    calcRollCount: function calcRollCount(width, height) {
      var jsRollDataEl = document.getElementById('js_rollData');
      var dataArray = JSON.parse(jsRollDataEl.dataset.rolldata);
      var rollWidth = dataArray[0];
      var rollLength = dataArray[1];
      var tapeten_rapportversatz = parseInt(dataArray[2]);
      var tapeten_rapportlaenge = parseInt(dataArray[3]);

      var sheetsLengthInclTrim = null;
      if (tapeten_rapportlaenge > 0) {
        sheetsLengthInclTrim = tapeten_rapportlaenge * Math.ceil((height + 5 + tapeten_rapportversatz) / tapeten_rapportlaenge);
      } else {
        sheetsLengthInclTrim = height + 5;
      }
      var sheetsPerRoll = Math.floor(rollLength / sheetsLengthInclTrim);
      var numberOfLanes = Math.ceil((width + 5) / rollWidth);

      return Math.ceil(numberOfLanes / sheetsPerRoll);
    },
    calculate: function calculate() {

      var width = parseFloat($('.product__fullinfo #txtWallWidth').val().replace(',', '.'));
      var height = parseFloat($('.product__fullinfo #txtWallHeight').val().replace(',', '.'));

      if (!width || !height) {
        $('.product__fullinfo #amountToBasket').val(1);
        return;
      }

      var calcRollCount = this.calcRollCount(width, height),
          option = calcRollCount - 1,
          wallpaper__note = '';

      if (calcRollCount == 1) {
        wallpaper__note = 'Für die Wandgrösse wird <b>' + calcRollCount + ' Rolle</b> benötigt';
      } else if (calcRollCount > 1) {
        wallpaper__note = 'Für die Wandgrösse werden <b>' + calcRollCount + ' Rollen</b> benötigt';
      }

      if (wallpaper__note) {
        $('.wallpaper__note').html(wallpaper__note).show();
      }

      $('select[name="qty"] option:eq(' + option + ')').prop('selected', true);
      $('select[name="qty"]').addClass('calculated');

      setTimeout(function () {
        $('select[name="qty"]').removeClass('calculated');
      }, 1000);
    },
    init: function init() {
      this.bindEvents();
    }
  };

  window.warollcalculator = warollcalculator;

  return warollcalculator;
});

